import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as tslib_1 from "tslib";
import classNames from "classnames";
import React from "react";
import { Generic } from "../../base";
import { combineRefs } from "../../utils";
import { DropdownContext } from "./dropdown-context";
export var DROPDOWN_DEFAULTS = {
  alignments: ["right"]
};
var initialState = {
  active: false
};
export var DropdownContainer = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DropdownContainer, _React$PureComponent);

  var _super = _createSuper(DropdownContainer);

  function DropdownContainer(props) {
    var _this;

    _classCallCheck(this, DropdownContainer);

    _this = _super.call(this, props);
    _this.ref = React.createRef();

    _this.handleClick = function (event) {
      if (_this.props.managed !== true && _this.active && _this.ref.current !== null) {
        if (event.target instanceof Element && !_this.ref.current.contains(event.target)) {
          _this.active = false;
        }
      }
    };

    _this.state = {
      active: props.active === true
    };
    return _this;
  }

  _createClass(DropdownContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("click", this.handleClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.handleClick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _classNames;

      var _a = this.props,
          active = _a.active,
          align = _a.align,
          className = _a.className,
          hoverable = _a.hoverable,
          innerRef = _a.innerRef,
          managed = _a.managed,
          up = _a.up,
          rest = tslib_1.__rest(_a, ["active", "align", "className", "hoverable", "innerRef", "managed", "up"]);

      return React.createElement(DropdownContext.Provider, {
        value: {
          active: this.active,
          setActive: function setActive(value) {
            return _this2.active = value;
          }
        }
      }, React.createElement(Generic, Object.assign({
        className: classNames("dropdown", (_classNames = {}, _defineProperty(_classNames, "is-".concat(align), align), _defineProperty(_classNames, "is-active", this.active), _defineProperty(_classNames, "is-hoverable", hoverable), _defineProperty(_classNames, "is-up", up), _classNames), className),
        ref: combineRefs(this.ref, innerRef)
      }, rest)));
    }
  }, {
    key: "active",
    get: function get() {
      return this.props.managed === true ? this.props.active === true : this.state.active;
    },
    set: function set(value) {
      if (this.props.managed !== true) {
        this.setState({
          active: value
        });
      }
    }
  }]);

  return DropdownContainer;
}(React.PureComponent);
DropdownContainer.displayName = "Dropdown.Container";